export const LANDING_DOMAIN = 'share.familymart.com.my'
